export default __webpack_public_path__ + "static/media/create.70f11400.svg";